import { render, staticRenderFns } from "./BuildingSocietyAttachmentsEscalated.vue?vue&type=template&id=2c86176a&scoped=true&"
import script from "./BuildingSocietyAttachmentsEscalated.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyAttachmentsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyAttachmentsEscalated.vue?vue&type=style&index=0&id=2c86176a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86176a",
  null
  
)

export default component.exports